export const alpha3LanguageHashMap = {
  abk: {
    nativeName: 'аҧсуа бызшәа',
    alpha2: 'ab',
    name: 'Abkhaz',
  },
  aar: {
    nativeName: 'Afaraf',
    alpha2: 'aa',
    name: 'Afar',
  },
  afr: {
    nativeName: 'Afrikaans',
    alpha2: 'af',
    name: 'Afrikaans',
  },
  aka: {
    nativeName: 'Akan',
    alpha2: 'ak',
    name: 'Akan',
  },
  sqi: {
    nativeName: 'Shqip',
    alpha2: 'sq',
    name: 'Albanian',
  },
  amh: {
    nativeName: 'አማርኛ',
    alpha2: 'am',
    name: 'Amharic',
  },
  arb: {
    nativeName: 'العربية',
    alpha2: 'ar',
    name: 'Arabic',
  },
  arg: {
    nativeName: 'aragonés',
    alpha2: 'an',
    name: 'Aragonese',
  },
  hye: {
    nativeName: 'Հայերեն',
    alpha2: 'hy',
    name: 'Armenian',
  },
  asm: {
    nativeName: 'অসমীয়া',
    alpha2: 'as',
    name: 'Assamese',
  },
  ava: {
    nativeName: 'авар мацӀ',
    alpha2: 'av',
    name: 'Avaric',
  },
  ave: {
    nativeName: 'avesta',
    alpha2: 'ae',
    name: 'Avestan',
  },
  aym: {
    nativeName: 'aymar aru',
    alpha2: 'ay',
    name: 'Aymara',
  },
  aze: {
    nativeName: 'azərbaycan dili',
    alpha2: 'az',
    name: 'Azerbaijani',
  },
  bam: {
    nativeName: 'bamanankan',
    alpha2: 'bm',
    name: 'Bambara',
  },
  bak: {
    nativeName: 'башҡорт теле',
    alpha2: 'ba',
    name: 'Bashkir',
  },
  eus: {
    nativeName: 'euskara',
    alpha2: 'eu',
    name: 'Basque',
  },
  bel: {
    nativeName: 'беларуская мова',
    alpha2: 'be',
    name: 'Belarusian',
  },
  ben: {
    nativeName: 'বাংলা',
    alpha2: 'bn',
    name: 'Bengali',
  },
  bih: {
    nativeName: 'भोजपुरी',
    alpha2: 'bh',
    name: 'Bihari',
  },
  bis: {
    nativeName: 'Bislama',
    alpha2: 'bi',
    name: 'Bislama',
  },
  bos: {
    nativeName: 'bosanski jezik',
    alpha2: 'bs',
    name: 'Bosnian',
  },
  bre: {
    nativeName: 'brezhoneg',
    alpha2: 'br',
    name: 'Breton',
  },
  bul: {
    nativeName: 'български език',
    alpha2: 'bg',
    name: 'Bulgarian',
  },
  mya: {
    nativeName: 'ဗမာစာ',
    alpha2: 'my',
    name: 'Burmese',
  },
  cat: {
    nativeName: 'català',
    alpha2: 'ca',
    name: 'Catalan',
  },
  cha: {
    nativeName: 'Chamoru',
    alpha2: 'ch',
    name: 'Chamorro',
  },
  che: {
    nativeName: 'нохчийн мотт',
    alpha2: 'ce',
    name: 'Chechen',
  },
  nya: {
    nativeName: 'chiCheŵa',
    alpha2: 'ny',
    name: 'Chichewa',
  },
  chi: {
    nativeName: '中文 (Zhōngwén)',
    alpha2: 'zh',
    name: 'Chinese',
  },
  chv: {
    nativeName: 'чӑваш чӗлхи',
    alpha2: 'cv',
    name: 'Chuvash',
  },
  cor: {
    nativeName: 'Kernewek',
    alpha2: 'kw',
    name: 'Cornish',
  },
  cos: {
    nativeName: 'corsu',
    alpha2: 'co',
    name: 'Corsican',
  },
  cre: {
    nativeName: 'ᓀᐦᐃᔭᐍᐏᐣ',
    alpha2: 'cr',
    name: 'Cree',
  },
  csp: {
    nativeName: 'castellano',
    alpha2: 'es',
    name: 'Castilian Spanish',
  },
  hrv: {
    nativeName: 'hrvatski jezik',
    alpha2: 'hr',
    name: 'Croatian',
  },
  ces: {
    nativeName: 'čeština',
    alpha2: 'cs',
    name: 'Czech',
  },
  cze: {
    nativeName: 'čeština',
    alpha2: 'cs',
    name: 'Czech',
  },
  dan: {
    nativeName: 'dansk',
    alpha2: 'da',
    name: 'Danish',
  },
  div: {
    nativeName: 'ދިވެހި',
    alpha2: 'dv',
    name: 'Divehi',
  },
  dut: {
    nativeName: 'Nederlands',
    alpha2: 'nl',
    name: 'Dutch',
  },
  dzo: {
    nativeName: 'རྫོང་ཁ',
    alpha2: 'dz',
    name: 'Dzongkha',
  },
  eng: {
    nativeName: 'English',
    alpha2: 'en',
    name: 'English',
  },
  epo: {
    nativeName: 'Esperanto',
    alpha2: 'eo',
    name: 'Esperanto',
  },
  est: {
    nativeName: 'eesti',
    alpha2: 'et',
    name: 'Estonian',
  },
  ewe: {
    nativeName: 'Eʋegbe',
    alpha2: 'ee',
    name: 'Ewe',
  },
  fao: {
    nativeName: 'føroyskt',
    alpha2: 'fo',
    name: 'Faroese',
  },
  fij: {
    nativeName: 'vosa Vakaviti',
    alpha2: 'fj',
    name: 'Fijian',
  },
  fin: {
    nativeName: 'suomi',
    alpha2: 'fi',
    name: 'Finnish',
  },
  frn: {
    nativeName: 'français',
    alpha2: 'fr',
    name: 'French',
  },
  ful: {
    nativeName: 'Fulfulde',
    alpha2: 'ff',
    name: 'Fula',
  },
  glg: {
    nativeName: 'galego',
    alpha2: 'gl',
    name: 'Galician',
  },
  kat: {
    nativeName: 'ქართული',
    alpha2: 'ka',
    name: 'Georgian',
  },
  de: {
    nativeName: 'Deutsch',
    alpha2: 'de',
    name: 'German',
  },
  gre: {
    nativeName: 'ελληνικά',
    alpha2: 'el',
    name: 'Greek (modern)',
  },
  grn: {
    nativeName: "Avañe'ẽ",
    alpha2: 'gn',
    name: 'Guaraní',
  },
  guj: {
    nativeName: 'ગુજરાતી',
    alpha2: 'gu',
    name: 'Gujarati',
  },
  hat: {
    nativeName: 'Kreyòl ayisyen',
    alpha2: 'ht',
    name: 'Haitian',
  },
  hau: {
    nativeName: '(Hausa) هَوُسَ',
    alpha2: 'ha',
    name: 'Hausa',
  },
  heb: {
    nativeName: 'עברית',
    alpha2: 'he',
    name: 'Hebrew (modern)',
  },
  her: {
    nativeName: 'Otjiherero',
    alpha2: 'hz',
    name: 'Herero',
  },
  hin: {
    nativeName: 'हिन्दी',
    alpha2: 'hi',
    name: 'Hindi',
  },
  hmo: {
    nativeName: 'Hiri Motu',
    alpha2: 'ho',
    name: 'Hiri Motu',
  },
  hun: {
    nativeName: 'magyar',
    alpha2: 'hu',
    name: 'Hungarian',
  },
  ina: {
    nativeName: 'Interlingua',
    alpha2: 'ia',
    name: 'Interlingua',
  },
  ind: {
    nativeName: 'Bahasa Indonesia',
    alpha2: 'id',
    name: 'Indonesian',
  },
  ile: {
    nativeName: 'Originally called Occidental',
    alpha2: 'ie',
    name: 'Interlingue',
  },
  gle: {
    nativeName: 'Gaeilge',
    alpha2: 'ga',
    name: 'Irish',
  },
  ibo: {
    nativeName: 'Asụsụ Igbo',
    alpha2: 'ig',
    name: 'Igbo',
  },
  ipk: {
    nativeName: 'Iñupiaq',
    alpha2: 'ik',
    name: 'Inupiaq',
  },
  ido: {
    nativeName: 'Ido',
    alpha2: 'io',
    name: 'Ido',
  },
  isl: {
    nativeName: 'Íslenska',
    alpha2: 'is',
    name: 'Icelandic',
  },
  ita: {
    nativeName: 'Italiano',
    alpha2: 'it',
    name: 'Italian',
  },
  iku: {
    nativeName: 'ᐃᓄᒃᑎᑐᑦ',
    alpha2: 'iu',
    name: 'Inuktitut',
  },
  jap: {
    nativeName: '日本語 (にほんご)',
    alpha2: 'ja',
    name: 'Japanese',
  },
  jav: {
    nativeName: 'ꦧꦱꦗꦮ',
    alpha2: 'jv',
    name: 'Javanese',
  },
  kal: {
    nativeName: 'kalaallisut',
    alpha2: 'kl',
    name: 'Kalaallisut',
  },
  kan: {
    nativeName: 'ಕನ್ನಡ',
    alpha2: 'kn',
    name: 'Kannada',
  },
  kau: {
    nativeName: 'Kanuri',
    alpha2: 'kr',
    name: 'Kanuri',
  },
  kas: {
    nativeName: 'कश्मीरी',
    alpha2: 'ks',
    name: 'Kashmiri',
  },
  kaz: {
    nativeName: 'қазақ тілі',
    alpha2: 'kk',
    name: 'Kazakh',
  },
  khm: {
    nativeName: 'ខ្មែរ',
    alpha2: 'km',
    name: 'Khmer',
  },
  kik: {
    nativeName: 'Gĩkũyũ',
    alpha2: 'ki',
    name: 'Kikuyu',
  },
  kin: {
    nativeName: 'Ikinyarwanda',
    alpha2: 'rw',
    name: 'Kinyarwanda',
  },
  kir: {
    nativeName: 'Кыргызча',
    alpha2: 'ky',
    name: 'Kyrgyz',
  },
  kom: {
    nativeName: 'коми кыв',
    alpha2: 'kv',
    name: 'Komi',
  },
  kon: {
    nativeName: 'Kikongo',
    alpha2: 'kg',
    name: 'Kongo',
  },
  kor: {
    nativeName: '한국어',
    alpha2: 'ko',
    name: 'Korean',
  },
  kur: {
    nativeName: 'Kurdî',
    alpha2: 'ku',
    name: 'Kurdish',
  },
  kua: {
    nativeName: 'Kuanyama',
    alpha2: 'kj',
    name: 'Kwanyama',
  },
  lat: {
    nativeName: 'latine',
    alpha2: 'la',
    name: 'Latin',
  },
  ltz: {
    nativeName: 'Lëtzebuergesch',
    alpha2: 'lb',
    name: 'Luxembourgish',
  },
  lug: {
    nativeName: 'Luganda',
    alpha2: 'lg',
    name: 'Ganda',
  },
  lim: {
    nativeName: 'Limburgs',
    alpha2: 'li',
    name: 'Limburgish',
  },
  lin: {
    nativeName: 'Lingála',
    alpha2: 'ln',
    name: 'Lingala',
  },
  lao: {
    nativeName: 'ພາສາລາວ',
    alpha2: 'lo',
    name: 'Lao',
  },
  lit: {
    nativeName: 'lietuvių kalba',
    alpha2: 'lt',
    name: 'Lithuanian',
  },
  lub: {
    nativeName: 'Tshiluba',
    alpha2: 'lu',
    name: 'Luba-Katanga',
  },
  lav: {
    nativeName: 'latviešu valoda',
    alpha2: 'lv',
    name: 'Latvian',
  },
  glv: {
    nativeName: 'Gaelg',
    alpha2: 'gv',
    name: 'Manx',
  },
  mkd: {
    nativeName: 'македонски јазик',
    alpha2: 'mk',
    name: 'Macedonian',
  },
  mlg: {
    nativeName: 'fiteny malagasy',
    alpha2: 'mg',
    name: 'Malagasy',
  },
  msa: {
    nativeName: 'bahasa Melayu',
    alpha2: 'ms',
    name: 'Malay',
  },
  mal: {
    nativeName: 'മലയാളം',
    alpha2: 'ml',
    name: 'Malayalam',
  },
  mlt: {
    nativeName: 'Malti',
    alpha2: 'mt',
    name: 'Maltese',
  },
  mnd: {
    nativeName: '官话',
    alpha2: 'zh',
    name: 'Mandarin',
  },
  cmn: {
    nativeName: '官话',
    alpha2: 'zh',
    name: 'Mandarin',
  },
  mri: {
    nativeName: 'te reo Māori',
    alpha2: 'mi',
    name: 'Māori',
  },
  mar: {
    nativeName: 'मराठी',
    alpha2: 'mr',
    name: 'Marathi (Marāṭhī)',
  },
  mah: {
    nativeName: 'Kajin M̧ajeļ',
    alpha2: 'mh',
    name: 'Marshallese',
  },
  mon: {
    nativeName: 'Монгол хэл',
    alpha2: 'mn',
    name: 'Mongolian',
  },
  nau: {
    nativeName: 'Dorerin Naoero',
    alpha2: 'na',
    name: 'Nauruan',
  },
  nav: {
    nativeName: 'Diné bizaad',
    alpha2: 'nv',
    name: 'Navajo',
  },
  nde: {
    nativeName: 'isiNdebele',
    alpha2: 'nd',
    name: 'Northern Ndebele',
  },
  nep: {
    nativeName: 'नेपाली',
    alpha2: 'ne',
    name: 'Nepali',
  },
  ndo: {
    nativeName: 'Owambo',
    alpha2: 'ng',
    name: 'Ndonga',
  },
  nob: {
    nativeName: 'Norsk bokmål',
    alpha2: 'nb',
    name: 'Norwegian Bokmål',
  },
  nno: {
    nativeName: 'Norsk nynorsk',
    alpha2: 'nn',
    name: 'Norwegian Nynorsk',
  },
  nor: {
    nativeName: 'Norsk',
    alpha2: 'no',
    name: 'Norwegian',
  },
  iii: {
    nativeName: 'ꆈꌠ꒿ Nuosuhxop',
    alpha2: 'ii',
    name: 'Nuosu',
  },
  nbl: {
    nativeName: 'isiNdebele',
    alpha2: 'nr',
    name: 'Southern Ndebele',
  },
  oci: {
    nativeName: 'occitan',
    alpha2: 'oc',
    name: 'Occitan',
  },
  oji: {
    nativeName: 'ᐊᓂᔑᓈᐯᒧᐎᓐ',
    alpha2: 'oj',
    name: 'Ojibwe',
  },
  chu: {
    nativeName: 'ѩзыкъ словѣньскъ',
    alpha2: 'cu',
    name: 'Old Church Slavonic',
  },
  orm: {
    nativeName: 'Afaan Oromoo',
    alpha2: 'om',
    name: 'Oromo',
  },
  ori: {
    nativeName: 'ଓଡ଼ିଆ',
    alpha2: 'or',
    name: 'Oriya',
  },
  oss: {
    nativeName: 'ирон æвзаг',
    alpha2: 'os',
    name: 'Ossetian',
  },
  pan: {
    nativeName: 'ਪੰਜਾਬੀ',
    alpha2: 'pa',
    name: '(Eastern) Punjabi',
  },
  pli: {
    nativeName: 'पाऴि',
    alpha2: 'pi',
    name: 'Pāli',
  },
  fas: {
    nativeName: 'فارسی',
    alpha2: 'fa',
    name: 'Persian (Farsi)',
  },
  pol: {
    nativeName: 'język polski',
    alpha2: 'pl',
    name: 'Polish',
  },
  pus: {
    nativeName: 'پښتو',
    alpha2: 'ps',
    name: 'Pashto',
  },
  por: {
    nativeName: 'Português',
    alpha2: 'pt',
    name: 'Portuguese',
  },
  que: {
    nativeName: 'Runa Simi',
    alpha2: 'qu',
    name: 'Quechua',
  },
  roh: {
    nativeName: 'rumantsch grischun',
    alpha2: 'rm',
    name: 'Romansh',
  },
  run: {
    nativeName: 'Ikirundi',
    alpha2: 'rn',
    name: 'Kirundi',
  },
  rom: {
    nativeName: 'Română',
    alpha2: 'ro',
    name: 'Romanian',
  },
  rus: {
    nativeName: 'Русский',
    alpha2: 'ru',
    name: 'Russian',
  },
  san: {
    nativeName: 'संस्कृतम्',
    alpha2: 'sa',
    name: 'Sanskrit (Saṁskṛta)',
  },
  srd: {
    nativeName: 'sardu',
    alpha2: 'sc',
    name: 'Sardinian',
  },
  snd: {
    nativeName: 'सिन्धी',
    alpha2: 'sd',
    name: 'Sindhi',
  },
  sme: {
    nativeName: 'Davvisámegiella',
    alpha2: 'se',
    name: 'Northern Sami',
  },
  smo: {
    nativeName: "gagana fa'a Samoa",
    alpha2: 'sm',
    name: 'Samoan',
  },
  sag: {
    nativeName: 'yângâ tî sängö',
    alpha2: 'sg',
    name: 'Sango',
  },
  srp: {
    nativeName: 'srpski jezik',
    settingsNativeName: 'srpski jezik',
    alpha2: 'sr',
    name: 'Serbian',
    latinCode: 'sr-Latn',
  },
  gla: {
    nativeName: 'Gàidhlig',
    alpha2: 'gd',
    name: 'Scottish Gaelic',
  },
  sna: {
    nativeName: 'chiShona',
    alpha2: 'sn',
    name: 'Shona',
  },
  sin: {
    nativeName: 'සිංහල',
    alpha2: 'si',
    name: 'Sinhalese',
  },
  slk: {
    nativeName: 'slovenčina',
    alpha2: 'sk',
    name: 'Slovak',
  },
  slv: {
    nativeName: 'slovenski jezik',
    alpha2: 'sl',
    name: 'Slovene',
  },
  som: {
    nativeName: 'Soomaaliga',
    alpha2: 'so',
    name: 'Somali',
  },
  sot: {
    nativeName: 'Sesotho',
    alpha2: 'st',
    name: 'Southern Sotho',
  },
  spa: {
    nativeName: 'Español',
    alpha2: 'es',
    name: 'Spanish',
  },
  sun: {
    nativeName: 'Basa Sunda',
    alpha2: 'su',
    name: 'Sundanese',
  },
  swa: {
    nativeName: 'Kiswahili',
    alpha2: 'sw',
    name: 'Swahili',
  },
  ssw: {
    nativeName: 'SiSwati',
    alpha2: 'ss',
    name: 'Swati',
  },
  swe: {
    nativeName: 'svenska',
    alpha2: 'sv',
    name: 'Swedish',
  },
  tam: {
    nativeName: 'தமிழ்',
    alpha2: 'ta',
    name: 'Tamil',
  },
  tel: {
    nativeName: 'తెలుగు',
    alpha2: 'te',
    name: 'Telugu',
  },
  tgk: {
    nativeName: 'тоҷикӣ',
    alpha2: 'tg',
    name: 'Tajik',
  },
  tha: {
    nativeName: 'ไทย',
    alpha2: 'th',
    name: 'Thai',
  },
  tir: {
    nativeName: 'ትግርኛ',
    alpha2: 'ti',
    name: 'Tigrinya',
  },
  bod: {
    nativeName: 'བོད་ཡིག',
    alpha2: 'bo',
    name: 'Tibetan Standard',
  },
  tuk: {
    nativeName: 'Türkmen',
    alpha2: 'tk',
    name: 'Turkmen',
  },
  tgl: {
    nativeName: 'Wikang Tagalog',
    alpha2: 'tl',
    name: 'Tagalog',
  },
  tsn: {
    nativeName: 'Setswana',
    alpha2: 'tn',
    name: 'Tswana',
  },
  ton: {
    nativeName: 'faka Tonga',
    alpha2: 'to',
    name: 'Tonga (Tonga Islands)',
  },
  tur: {
    nativeName: 'Türkçe',
    alpha2: 'tr',
    name: 'Turkish',
  },
  tso: {
    nativeName: 'Xitsonga',
    alpha2: 'ts',
    name: 'Tsonga',
  },
  tat: {
    nativeName: 'татар теле',
    alpha2: 'tt',
    name: 'Tatar',
  },
  twi: {
    nativeName: 'Twi',
    alpha2: 'tw',
    name: 'Twi',
  },
  tah: {
    nativeName: 'Reo Tahiti',
    alpha2: 'ty',
    name: 'Tahitian',
  },
  uig: {
    nativeName: 'ئۇيغۇرچە',
    alpha2: 'ug',
    name: 'Uyghur',
  },
  ukr: {
    nativeName: 'Українська',
    alpha2: 'uk',
    name: 'Ukrainian',
  },
  urd: {
    nativeName: 'اردو',
    alpha2: 'ur',
    name: 'Urdu',
  },
  uzb: {
    nativeName: 'Oʻzbek',
    alpha2: 'uz',
    name: 'Uzbek',
  },
  ven: {
    nativeName: 'Tshivenḓa',
    alpha2: 've',
    name: 'Venda',
  },
  vie: {
    nativeName: 'Tiếng Việt',
    alpha2: 'vi',
    name: 'Vietnamese',
  },
  vol: {
    nativeName: 'Volapük',
    alpha2: 'vo',
    name: 'Volapük',
  },
  wln: {
    nativeName: 'walon',
    alpha2: 'wa',
    name: 'Walloon',
  },
  cym: {
    nativeName: 'Cymraeg',
    alpha2: 'cy',
    name: 'Welsh',
  },
  wol: {
    nativeName: 'Wollof',
    alpha2: 'wo',
    name: 'Wolof',
  },
  fry: {
    nativeName: 'Frysk',
    alpha2: 'fy',
    name: 'Western Frisian',
  },
  xho: {
    nativeName: 'isiXhosa',
    alpha2: 'xh',
    name: 'Xhosa',
  },
  yid: {
    nativeName: 'ייִדיש',
    alpha2: 'yi',
    name: 'Yiddish',
  },
  yor: {
    nativeName: 'Yorùbá',
    alpha2: 'yo',
    name: 'Yoruba',
  },
  zha: {
    nativeName: 'Saɯ cueŋƅ',
    alpha2: 'za',
    name: 'Zhuang',
  },
  zul: {
    nativeName: 'isiZulu',
    alpha2: 'zu',
    name: 'Zulu',
  },
};

// https://github.com/mozilla/language-mapping-list/blob/master/language-mapping-list.js
// player support
export const LanguageMapping = {
  ach: {
    nativeName: 'Lwo',
    englishName: 'Acholi',
  },
  ady: {
    nativeName: 'Адыгэбзэ',
    englishName: 'Adyghe',
  },
  af: {
    nativeName: 'Afrikaans',
    englishName: 'Afrikaans',
  },
  'af-NA': {
    nativeName: 'Afrikaans (Namibia)',
    englishName: 'Afrikaans (Namibia)',
  },
  'af-ZA': {
    nativeName: 'Afrikaans (South Africa)',
    englishName: 'Afrikaans (South Africa)',
  },
  ak: {
    nativeName: 'Tɕɥi',
    englishName: 'Akan',
  },
  ar: {
    nativeName: 'العربية',
    englishName: 'Arabic',
  },
  'ar-AR': {
    nativeName: 'العربية',
    englishName: 'Arabic',
  },
  'ar-MA': {
    nativeName: 'العربية',
    englishName: 'Arabic (Morocco)',
  },
  'ar-SA': {
    nativeName: 'العربية (السعودية)',
    englishName: 'Arabic (Saudi Arabia)',
  },
  'ay-BO': {
    nativeName: 'Aymar aru',
    englishName: 'Aymara',
  },
  az: {
    nativeName: 'Azərbaycan dili',
    englishName: 'Azerbaijani',
  },
  'az-AZ': {
    nativeName: 'Azərbaycan dili',
    englishName: 'Azerbaijani',
  },
  'be-BY': {
    nativeName: 'Беларуская',
    englishName: 'Belarusian',
  },
  bg: {
    nativeName: 'Български',
    englishName: 'Bulgarian',
  },
  'bg-BG': {
    nativeName: 'Български',
    englishName: 'Bulgarian',
  },
  bn: {
    nativeName: 'বাংলা',
    englishName: 'Bengali',
  },
  'bn-IN': {
    nativeName: 'বাংলা (ভারত)',
    englishName: 'Bengali (India)',
  },
  'bn-BD': {
    nativeName: 'বাংলা(বাংলাদেশ)',
    englishName: 'Bengali (Bangladesh)',
  },
  br: {
    nativeName: 'Brezhoneg',
    englishName: 'Breton',
  },
  'bs-BA': {
    nativeName: 'Bosanski',
    englishName: 'Bosnian',
  },
  ca: {
    nativeName: 'Català',
    englishName: 'Catalan',
  },
  'ca-ES': {
    nativeName: 'Català',
    englishName: 'Catalan',
  },
  cak: {
    nativeName: 'Maya Kaqchikel',
    englishName: 'Kaqchikel',
  },
  'ck-US': {
    nativeName: 'ᏣᎳᎩ (tsalagi)',
    englishName: 'Cherokee',
  },
  cs: {
    nativeName: 'Čeština',
    englishName: 'Czech',
  },
  'cs-CZ': {
    nativeName: 'Čeština',
    englishName: 'Czech',
  },
  cy: {
    nativeName: 'Cymraeg',
    englishName: 'Welsh',
  },
  'cy-GB': {
    nativeName: 'Cymraeg',
    englishName: 'Welsh',
  },
  da: {
    nativeName: 'Dansk',
    englishName: 'Danish',
  },
  'da-DK': {
    nativeName: 'Dansk',
    englishName: 'Danish',
  },
  de: {
    nativeName: 'Deutsch',
    englishName: 'German',
  },
  'de-AT': {
    nativeName: 'Deutsch (Österreich)',
    englishName: 'German (Austria)',
  },
  'de-DE': {
    nativeName: 'Deutsch (Deutschland)',
    englishName: 'German (Germany)',
  },
  'de-CH': {
    nativeName: 'Deutsch (Schweiz)',
    englishName: 'German (Switzerland)',
  },
  dsb: {
    nativeName: 'Dolnoserbšćina',
    englishName: 'Lower Sorbian',
  },
  el: {
    nativeName: 'Ελληνικά',
    englishName: 'Greek',
  },
  'el-GR': {
    nativeName: 'Ελληνικά',
    englishName: 'Greek (Greece)',
  },
  en: {
    nativeName: 'English',
    englishName: 'English',
  },
  'en-GB': {
    nativeName: 'English (UK)',
    englishName: 'English (UK)',
  },
  'en-AU': {
    nativeName: 'English (Australia)',
    englishName: 'English (Australia)',
  },
  'en-CA': {
    nativeName: 'English (Canada)',
    englishName: 'English (Canada)',
  },
  'en-IE': {
    nativeName: 'English (Ireland)',
    englishName: 'English (Ireland)',
  },
  'en-IN': {
    nativeName: 'English (India)',
    englishName: 'English (India)',
  },
  'en-PI': {
    nativeName: 'English (Pirate)',
    englishName: 'English (Pirate)',
  },
  'en-UD': {
    nativeName: 'English (Upside Down)',
    englishName: 'English (Upside Down)',
  },
  'en-US': {
    nativeName: 'English (US)',
    englishName: 'English (US)',
  },
  'en-ZA': {
    nativeName: 'English (South Africa)',
    englishName: 'English (South Africa)',
  },
  'en@pirate': {
    nativeName: 'English (Pirate)',
    englishName: 'English (Pirate)',
  },
  eo: {
    nativeName: 'Esperanto',
    englishName: 'Esperanto',
  },
  'eo-EO': {
    nativeName: 'Esperanto',
    englishName: 'Esperanto',
  },
  es: {
    nativeName: 'Español',
    englishName: 'Spanish',
  },
  'es-AR': {
    nativeName: 'Español (Argentine)',
    englishName: 'Spanish (Argentina)',
  },
  'es-419': {
    nativeName: 'Español (Latinoamérica)',
    englishName: 'Spanish (Latin America)',
  },
  'es-CL': {
    nativeName: 'Español (Chile)',
    englishName: 'Spanish (Chile)',
  },
  'es-CO': {
    nativeName: 'Español (Colombia)',
    englishName: 'Spanish (Colombia)',
  },
  'es-EC': {
    nativeName: 'Español (Ecuador)',
    englishName: 'Spanish (Ecuador)',
  },
  'es-ES': {
    nativeName: 'Español (España)',
    englishName: 'Spanish (Spain)',
  },
  'es-LA': {
    nativeName: 'Español (Latinoamérica)',
    englishName: 'Spanish (Latin America)',
  },
  'es-NI': {
    nativeName: 'Español (Nicaragua)',
    englishName: 'Spanish (Nicaragua)',
  },
  'es-MX': {
    nativeName: 'Español (México)',
    englishName: 'Spanish (Mexico)',
  },
  'es-US': {
    nativeName: 'Español (Estados Unidos)',
    englishName: 'Spanish (United States)',
  },
  'es-VE': {
    nativeName: 'Español (Venezuela)',
    englishName: 'Spanish (Venezuela)',
  },
  et: {
    nativeName: 'eesti keel',
    englishName: 'Estonian',
  },
  'et-EE': {
    nativeName: 'Eesti (Estonia)',
    englishName: 'Estonian (Estonia)',
  },
  eu: {
    nativeName: 'Euskara',
    englishName: 'Basque',
  },
  'eu-ES': {
    nativeName: 'Euskara',
    englishName: 'Basque',
  },
  fa: {
    nativeName: 'فارسی',
    englishName: 'Persian',
  },
  'fa-IR': {
    nativeName: 'فارسی',
    englishName: 'Persian',
  },
  'fb-LT': {
    nativeName: 'Leet Speak',
    englishName: 'Leet',
  },
  ff: {
    nativeName: 'Fulah',
    englishName: 'Fulah',
  },
  fi: {
    nativeName: 'Suomi',
    englishName: 'Finnish',
  },
  'fi-FI': {
    nativeName: 'Suomi',
    englishName: 'Finnish',
  },
  'fo-FO': {
    nativeName: 'Føroyskt',
    englishName: 'Faroese',
  },
  fr: {
    nativeName: 'Français',
    englishName: 'French',
  },
  'fr-CA': {
    nativeName: 'Français (Canada)',
    englishName: 'French (Canada)',
  },
  'fr-FR': {
    nativeName: 'Français (France)',
    englishName: 'French (France)',
  },
  'fr-BE': {
    nativeName: 'Français (Belgique)',
    englishName: 'French (Belgium)',
  },
  'fr-CH': {
    nativeName: 'Français (Suisse)',
    englishName: 'French (Switzerland)',
  },
  'fy-NL': {
    nativeName: 'Frysk',
    englishName: 'Frisian (West)',
  },
  ga: {
    nativeName: 'Gaeilge',
    englishName: 'Irish',
  },
  'ga-IE': {
    nativeName: 'Gaeilge',
    englishName: 'Irish',
  },
  gd: {
    nativeName: 'Gàidhlig',
    englishName: 'Gaelic',
  },
  gl: {
    nativeName: 'Galego',
    englishName: 'Galician',
  },
  'gl-ES': {
    nativeName: 'Galego',
    englishName: 'Galician',
  },
  'gn-PY': {
    nativeName: "Avañe'ẽ",
    englishName: 'Guarani',
  },
  'gu-IN': {
    nativeName: 'ગુજરાતી',
    englishName: 'Gujarati',
  },
  gv: {
    nativeName: 'Gaelg',
    englishName: 'Manx',
  },
  'gx-GR': {
    nativeName: 'Ἑλληνική ἀρχαία',
    englishName: 'Classical Greek',
  },
  he: {
    nativeName: 'עברית',
    englishName: 'Hebrew',
  },
  'he-IL': {
    nativeName: 'עברית',
    englishName: 'Hebrew',
  },
  hi: {
    nativeName: 'हिन्दी',
    englishName: 'Hindi',
  },
  'hi-IN': {
    nativeName: 'हिन्दी',
    englishName: 'Hindi',
  },
  hr: {
    nativeName: 'Hrvatski',
    englishName: 'Croatian',
  },
  'hr-HR': {
    nativeName: 'Hrvatski',
    englishName: 'Croatian',
  },
  hsb: {
    nativeName: 'Hornjoserbšćina',
    englishName: 'Upper Sorbian',
  },
  ht: {
    nativeName: 'Kreyòl',
    englishName: 'Haitian Creole',
  },
  hu: {
    nativeName: 'Magyar',
    englishName: 'Hungarian',
  },
  'hu-HU': {
    nativeName: 'Magyar',
    englishName: 'Hungarian',
  },
  'hy-AM': {
    nativeName: 'Հայերեն',
    englishName: 'Armenian',
  },
  id: {
    nativeName: 'Bahasa Indonesia',
    englishName: 'Indonesian',
  },
  'id-ID': {
    nativeName: 'Bahasa Indonesia',
    englishName: 'Indonesian',
  },
  is: {
    nativeName: 'Íslenska',
    englishName: 'Icelandic',
  },
  'is-IS': {
    nativeName: 'Íslenska (Iceland)',
    englishName: 'Icelandic (Iceland)',
  },
  it: {
    nativeName: 'Italiano',
    englishName: 'Italian',
  },
  'it-IT': {
    nativeName: 'Italiano',
    englishName: 'Italian',
  },
  ja: {
    nativeName: '日本語',
    englishName: 'Japanese',
  },
  'ja-JP': {
    nativeName: '日本語 (日本)',
    englishName: 'Japanese (Japan)',
  },
  'jv-ID': {
    nativeName: 'Basa Jawa',
    englishName: 'Javanese',
  },
  'ka-GE': {
    nativeName: 'ქართული',
    englishName: 'Georgian',
  },
  'kk-KZ': {
    nativeName: 'Қазақша',
    englishName: 'Kazakh',
  },
  km: {
    nativeName: 'ភាសាខ្មែរ',
    englishName: 'Khmer',
  },
  'km-KH': {
    nativeName: 'ភាសាខ្មែរ',
    englishName: 'Khmer',
  },
  kab: {
    nativeName: 'Taqbaylit',
    englishName: 'Kabyle',
  },
  kn: {
    nativeName: 'ಕನ್ನಡ',
    englishName: 'Kannada',
  },
  'kn-IN': {
    nativeName: 'ಕನ್ನಡ (India)',
    englishName: 'Kannada (India)',
  },
  ko: {
    nativeName: '한국어',
    englishName: 'Korean',
  },
  'ko-KR': {
    nativeName: '한국어 (한국)',
    englishName: 'Korean (Korea)',
  },
  'ku-TR': {
    nativeName: 'Kurdî',
    englishName: 'Kurdish',
  },
  kw: {
    nativeName: 'Kernewek',
    englishName: 'Cornish',
  },
  la: {
    nativeName: 'Latin',
    englishName: 'Latin',
  },
  'la-VA': {
    nativeName: 'Latin',
    englishName: 'Latin',
  },
  lb: {
    nativeName: 'Lëtzebuergesch',
    englishName: 'Luxembourgish',
  },
  'li-NL': {
    nativeName: 'Lèmbörgs',
    englishName: 'Limburgish',
  },
  lt: {
    nativeName: 'Lietuvių',
    englishName: 'Lithuanian',
  },
  'lt-LT': {
    nativeName: 'Lietuvių',
    englishName: 'Lithuanian',
  },
  lv: {
    nativeName: 'Latviešu',
    englishName: 'Latvian',
  },
  'lv-LV': {
    nativeName: 'Latviešu',
    englishName: 'Latvian',
  },
  mai: {
    nativeName: 'मैथिली, মৈথিলী',
    englishName: 'Maithili',
  },
  'mg-MG': {
    nativeName: 'Malagasy',
    englishName: 'Malagasy',
  },
  mk: {
    nativeName: 'Македонски',
    englishName: 'Macedonian',
  },
  'mk-MK': {
    nativeName: 'Македонски (Македонски)',
    englishName: 'Macedonian (Macedonian)',
  },
  ml: {
    nativeName: 'മലയാളം',
    englishName: 'Malayalam',
  },
  'ml-IN': {
    nativeName: 'മലയാളം',
    englishName: 'Malayalam',
  },
  'mn-MN': {
    nativeName: 'Монгол',
    englishName: 'Mongolian',
  },
  mr: {
    nativeName: 'मराठी',
    englishName: 'Marathi',
  },
  'mr-IN': {
    nativeName: 'मराठी',
    englishName: 'Marathi',
  },
  ms: {
    nativeName: 'Bahasa Melayu',
    englishName: 'Malay',
  },
  'ms-MY': {
    nativeName: 'Bahasa Melayu',
    englishName: 'Malay',
  },
  mt: {
    nativeName: 'Malti',
    englishName: 'Maltese',
  },
  'mt-MT': {
    nativeName: 'Malti',
    englishName: 'Maltese',
  },
  my: {
    nativeName: 'ဗမာစကာ',
    englishName: 'Burmese',
  },
  no: {
    nativeName: 'Norsk',
    englishName: 'Norwegian',
  },
  nb: {
    nativeName: 'Norsk (bokmål)',
    englishName: 'Norwegian (bokmal)',
  },
  'nb-NO': {
    nativeName: 'Norsk (bokmål)',
    englishName: 'Norwegian (bokmal)',
  },
  ne: {
    nativeName: 'नेपाली',
    englishName: 'Nepali',
  },
  'ne-NP': {
    nativeName: 'नेपाली',
    englishName: 'Nepali',
  },
  nl: {
    nativeName: 'Nederlands',
    englishName: 'Dutch',
  },
  'nl-BE': {
    nativeName: 'Nederlands (België)',
    englishName: 'Dutch (Belgium)',
  },
  'nl-NL': {
    nativeName: 'Nederlands (Nederland)',
    englishName: 'Dutch (Netherlands)',
  },
  'nn-NO': {
    nativeName: 'Norsk (nynorsk)',
    englishName: 'Norwegian (nynorsk)',
  },
  oc: {
    nativeName: 'Occitan',
    englishName: 'Occitan',
  },
  'or-IN': {
    nativeName: 'ଓଡ଼ିଆ',
    englishName: 'Oriya',
  },
  pa: {
    nativeName: 'ਪੰਜਾਬੀ',
    englishName: 'Punjabi',
  },
  'pa-IN': {
    nativeName: 'ਪੰਜਾਬੀ (ਭਾਰਤ ਨੂੰ)',
    englishName: 'Punjabi (India)',
  },
  pl: {
    nativeName: 'Polski',
    englishName: 'Polish',
  },
  'pl-PL': {
    nativeName: 'Polski',
    englishName: 'Polish',
  },
  'ps-AF': {
    nativeName: 'پښتو',
    englishName: 'Pashto',
  },
  pt: {
    nativeName: 'Português',
    englishName: 'Portuguese',
  },
  'pt-BR': {
    nativeName: 'Português (Brasil)',
    englishName: 'Portuguese (Brazil)',
  },
  'pt-PT': {
    nativeName: 'Português (Portugal)',
    englishName: 'Portuguese (Portugal)',
  },
  'qu-PE': {
    nativeName: 'Qhichwa',
    englishName: 'Quechua',
  },
  'rm-CH': {
    nativeName: 'Rumantsch',
    englishName: 'Romansh',
  },
  ro: {
    nativeName: 'Română',
    englishName: 'Romanian',
  },
  'ro-RO': {
    nativeName: 'Română',
    englishName: 'Romanian',
  },
  ru: {
    nativeName: 'Русский',
    englishName: 'Russian',
  },
  'ru-RU': {
    nativeName: 'Русский',
    englishName: 'Russian',
  },
  'sa-IN': {
    nativeName: 'संस्कृतम्',
    englishName: 'Sanskrit',
  },
  'se-NO': {
    nativeName: 'Davvisámegiella',
    englishName: 'Northern Sámi',
  },
  sh: {
    nativeName: 'српскохрватски',
    englishName: 'Serbo-Croatian',
  },
  'si-LK': {
    nativeName: 'පළාත',
    englishName: 'Sinhala (Sri Lanka)',
  },
  sk: {
    nativeName: 'Slovenčina',
    englishName: 'Slovak',
  },
  'sk-SK': {
    nativeName: 'Slovenčina (Slovakia)',
    englishName: 'Slovak (Slovakia)',
  },
  sl: {
    nativeName: 'Slovenščina',
    englishName: 'Slovenian',
  },
  'sl-SI': {
    nativeName: 'Slovenščina',
    englishName: 'Slovenian',
  },
  'so-SO': {
    nativeName: 'Soomaaliga',
    englishName: 'Somali',
  },
  sq: {
    nativeName: 'Shqip',
    englishName: 'Albanian',
  },
  'sq-AL': {
    nativeName: 'Shqip',
    englishName: 'Albanian',
  },
  sr: {
    nativeName: 'Srpski',
    englishName: 'Serbian',
  },
  'sr-RS': {
    nativeName: 'Srpski (Serbia)',
    englishName: 'Serbian (Serbia)',
  },
  su: {
    nativeName: 'Basa Sunda',
    englishName: 'Sundanese',
  },
  sv: {
    nativeName: 'Svenska',
    englishName: 'Swedish',
  },
  'sv-SE': {
    nativeName: 'Svenska',
    englishName: 'Swedish',
  },
  sw: {
    nativeName: 'Kiswahili',
    englishName: 'Swahili',
  },
  'sw-KE': {
    nativeName: 'Kiswahili',
    englishName: 'Swahili (Kenya)',
  },
  ta: {
    nativeName: 'தமிழ்',
    englishName: 'Tamil',
  },
  'ta-IN': {
    nativeName: 'தமிழ்',
    englishName: 'Tamil',
  },
  te: {
    nativeName: 'తెలుగు',
    englishName: 'Telugu',
  },
  'te-IN': {
    nativeName: 'తెలుగు',
    englishName: 'Telugu',
  },
  tg: {
    nativeName: 'забо́ни тоҷикӣ́',
    englishName: 'Tajik',
  },
  'tg-TJ': {
    nativeName: 'тоҷикӣ',
    englishName: 'Tajik',
  },
  th: {
    nativeName: 'ภาษาไทย',
    englishName: 'Thai',
  },
  'th-TH': {
    nativeName: 'ภาษาไทย (ประเทศไทย)',
    englishName: 'Thai (Thailand)',
  },
  tl: {
    nativeName: 'Filipino',
    englishName: 'Filipino',
  },
  'tl-PH': {
    nativeName: 'Filipino',
    englishName: 'Filipino',
  },
  tlh: {
    nativeName: 'tlhIngan-Hol',
    englishName: 'Klingon',
  },
  tr: {
    nativeName: 'Türkçe',
    englishName: 'Turkish',
  },
  'tr-TR': {
    nativeName: 'Türkçe',
    englishName: 'Turkish',
  },
  'tt-RU': {
    nativeName: 'татарча',
    englishName: 'Tatar',
  },
  uk: {
    nativeName: 'Українська',
    englishName: 'Ukrainian',
  },
  'uk-UA': {
    nativeName: 'Українська',
    englishName: 'Ukrainian',
  },
  ur: {
    nativeName: 'اردو',
    englishName: 'Urdu',
  },
  'ur-PK': {
    nativeName: 'اردو',
    englishName: 'Urdu',
  },
  uz: {
    nativeName: "O'zbek",
    englishName: 'Uzbek',
  },
  'uz-UZ': {
    nativeName: "O'zbek",
    englishName: 'Uzbek',
  },
  vi: {
    nativeName: 'Tiếng Việt',
    englishName: 'Vietnamese',
  },
  'vi-VN': {
    nativeName: 'Tiếng Việt',
    englishName: 'Vietnamese',
  },
  'xh-ZA': {
    nativeName: 'isiXhosa',
    englishName: 'Xhosa',
  },
  yi: {
    nativeName: 'ייִדיש',
    englishName: 'Yiddish',
  },
  'yi-DE': {
    nativeName: 'ייִדיש (German)',
    englishName: 'Yiddish (German)',
  },
  zh: {
    nativeName: '中文',
    englishName: 'Chinese',
  },
  'zh-Hans': {
    nativeName: '中文简体',
    englishName: 'Chinese Simplified',
  },
  'zh-Hant': {
    nativeName: '中文繁體',
    englishName: 'Chinese Traditional',
  },
  'zh-CN': {
    nativeName: '中文（中国）',
    englishName: 'Chinese Simplified (China)',
  },
  'zh-HK': {
    nativeName: '中文（香港）',
    englishName: 'Chinese Traditional (Hong Kong)',
  },
  'zh-SG': {
    nativeName: '中文（新加坡）',
    englishName: 'Chinese Simplified (Singapore)',
  },
  'zh-TW': {
    nativeName: '中文（台灣）',
    englishName: 'Chinese Traditional (Taiwan)',
  },
  'zu-ZA': {
    nativeName: 'isiZulu',
    englishName: 'Zulu',
  },
};
